/* eslint-disable no-unused-vars */
export default class PromiseSource<T> {
  private resolveFn!: (value: T | PromiseLike<T>) => void;

  private rejectFn!: (reason?: any) => void;

  private readonly _promise: Promise<T>;

  // eslint-disable-next-line no-underscore-dangle
  public get promise(): Promise<T> { return this._promise; }

  constructor() {
    // eslint-disable-next-line no-underscore-dangle
    this._promise = new Promise<T>((resolve, reject) => {
      this.resolveFn = resolve;
      this.rejectFn = reject;
    });
  }

  public resolve(value: T): void {
    this.resolveFn(value);
  }

  public reject(reason?: any): void {
    this.rejectFn(reason);
  }
}
